export default ((theme) => ({
  icon: {
    fontSize: 16
  }
}));
